var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Callout = require('../../../components/callout.jsx');
var SearchForm = require('./searchForm.jsx');
var Specialist = require('./specialist.jsx');
var SpecialistList = require('./specialistList.jsx');

var FindASpecialist = createReactClass({
    mixins: [PureRenderMixin],

    componentWillUnmount: function() {
        this.props.clearError();
    },

    getErrMsg: function(){
        var errMsg = '';
        var error = this.props.error;
        if(error && Object.keys(error).length > 0){
            if(error.response){
                errMsg = error.response.data.message || error.response.data;
            }else if(error.message){
                errMsg = error.message;
            }else{
                errMsg = error;
            }
        }
        return errMsg;
    },

    getResultContent: function() {
        var resultContent = null;

        if(this.props.specialists.data.length > 0){
            resultContent = (
                <div>
                    {this.props.specialists.postalCode &&
                        <p className="result-summary">{this.props.specialists.data.length} {this.props.specialists.data.length > 1 ? 'Doctors' : 'Doctor'} Closest to You</p>
                    }
                    <SpecialistList
                        specialists={this.props.specialists.data}
                        mySpecialist={this.props.specialist.mySpecialist}
                        setMySpecialist={this.props.setMySpecialist}
                        clearMySpecialist={this.props.clearMySpecialist}
                        token={this.props.token}
                        handleSpecialistUnauthenticatedUser={this.props.handleSpecialistUnauthenticatedUser}
                        clickTracking={this.props.clickTracking} />
                </div>
            );
        }else if(this.props.specialists.postalCode){
            resultContent = (
                <div className="no-results">
                    <p>Sorry, we could not find any doctors in your zip code,<br /> please try another one</p>
                </div>
            );
        }

        return resultContent;
    },

    render: function(){
        var errMsg = this.getErrMsg();

        return (
            <div id="findASpecialist" className={(this.props.specialists.data.length || Object.keys(this.props.specialist.mySpecialist).length > 0) ? 'with-results' : 'without-results'}>
                <div className="search">
                    <div className="search-inner">
                        <h1>Find a Gi Specialist</h1>
                        <p>Enter your ZIP Code below to find local accredited gastroenterologists.</p>
                        <SearchForm
                            postalCode={this.props.specialists.postalCode}
                            searchSpecialists={this.props.searchSpecialists}
                            clickTracking={this.props.clickTracking} />
                    </div>
                </div>

                {errMsg &&
                    <div className="row column">
                        <Callout type="alert" message={errMsg} handleClose={this.props.clearError} />
                    </div>
                }

                <div className="result-body row column">
                    {Object.keys(this.props.specialist.mySpecialist).length > 0 &&
                        <ul className="my-specialist-list no-bullet">
                            <Specialist
                                isMySpecialist
                                specialist={this.props.specialist.mySpecialist}
                                setMySpecialist={this.props.setMySpecialist}
                                clearMySpecialist={this.props.clearMySpecialist}
                                token={this.props.token}
                                handleSpecialistUnauthenticatedUser={this.props.handleSpecialistUnauthenticatedUser}
                                clickTracking={this.props.clickTracking} />
                        </ul>
                    }

                    {this.getResultContent()}
                </div>
            </div>
        )
    }
});

module.exports = FindASpecialist;



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/components/layout/findASpecialist.jsx